const controller = '/faq'
export default axios => ({
  getFaq(obj) {
    return axios.get(`${controller}`, obj)
  },
})